import { ToastContentProps } from 'react-toastify';
import styles from './Toast.module.scss';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';

type ToastPropsWithContext = {
  context: ToastContentProps<unknown>;
  description?: string | React.ReactNode;
};

type ToastPropsWithTitle = {
  title: string;
  description?: string | React.ReactNode;
};

export const Toast: React.FC<ToastPropsWithContext | ToastPropsWithTitle> = (
  props,
) => {
  const i18n = useScopedTranslation('uikit.toast');
  const title =
    'title' in props
      ? props.title
      : i18n.t(`default_title_${props.context.toastProps.type}`);

  return (
    <div className={styles.toastContent}>
      <div className={styles.toastTitle} data-test-id="toast-title">
        {title}
      </div>
      {props.description && (
        <div
          className={styles.toastDescription}
          data-test-id="toast-description"
        >
          {props.description}
        </div>
      )}
    </div>
  );
};
